import { STORAGE_KEYS } from "../../../shared/config/constants";

export const TRACE_MODE_RAW = "raw";
export const TRACE_MODE_POLISHED = "polished";
export const TRACE_MODE_OFF = "off";

export type ReasoningNarrationMode =
  | typeof TRACE_MODE_RAW
  | typeof TRACE_MODE_POLISHED
  | typeof TRACE_MODE_OFF;

export interface ReasoningNarrationConfig {
  mode: ReasoningNarrationMode;
  model: string;
}

const DEFAULT_NARRATOR_MODEL = "gpt-5.4-mini";
const DEFAULT_NARRATOR_MODE: ReasoningNarrationMode = TRACE_MODE_POLISHED;

function normalizeMode(value: string | null | undefined): ReasoningNarrationMode {
  const normalized = String(value || "").trim().toLowerCase();
  if (
    normalized === TRACE_MODE_RAW ||
    normalized === TRACE_MODE_POLISHED ||
    normalized === TRACE_MODE_OFF
  ) {
    return normalized;
  }
  return DEFAULT_NARRATOR_MODE;
}

function readStorageValue(key: string): string | null {
  try {
    return typeof localStorage === "undefined" ? null : localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function getReasoningNarrationConfig(): ReasoningNarrationConfig {
  const mode = normalizeMode(readStorageValue(STORAGE_KEYS.NARRATOR_MODE));
  const configuredModel = readStorageValue(STORAGE_KEYS.NARRATOR_MODEL);
  const model = configuredModel?.trim() || DEFAULT_NARRATOR_MODEL;
  return { mode, model };
}
